import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { RoutedDialogRouteData } from './routed-dialog.module';

@Injectable({
    providedIn: 'root',
})
export class RoutedDialogWrapperService {
    constructor(private router: Router) {}

    resolve() {
        const originalRoute: RoutedDialogRouteData['originalRoute'] = {
            navigatedFromRoute: this.router.routerState.snapshot.url,
        };
        return Promise.resolve(originalRoute);
    }
}

export function getResolvedUrl(route: ActivatedRouteSnapshot): string {
    return route.pathFromRoot
        .map((v) =>
            v.url
                .map((segment) => segment.toString())
                .filter(Boolean)
                .join('/')
        )
        .filter(Boolean)
        .join('/');
}
